import React, { useState } from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { API, graphqlOperation } from 'aws-amplify';
import { ButtonTemplate } from '../button/button-template';
import { DeleteUser } from '../../lib/graphql-command/user-command';
import { CancelSubscription } from '../../lib/graphql-command/command';

const useStyle = makeStyles(theme => ({
    title: {
        padding: '0 5px'
    },
    closeButton: {
        position: 'absolute',
        color: theme.palette.grey[500]
    },
}))


export const CancelSubscriptionDialog = ({open, setOpen, subscription, getListSub, setMessage}) => {
    const [disabled, setDisabled] = useState(false);

    const handleCancel = () => {
        setDisabled(true)
        API.graphql(graphqlOperation(CancelSubscription, {UserSubscriptionID: subscription.UserSubscriptionID}))
        .then(result => {
            setDisabled(false)
            setOpen(false)
            getListSub();
            setMessage('You successfully canceled subscription plan')

        })
        .catch(err => console.log(err))
    }

    return (
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
            <DialogTitle className={useStyle().title}>
                <Grid container direction='row' justify='flex-end'>
                    <Grid item>
                        <IconButton onClick={() => setOpen(false)}>
                            <CloseIcon className={useStyle().closeButton} />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <Box py={5} textAlign='center'>
                    Are you sure you want to cancel this subscription?
                </Box>
            </DialogContent>
            <DialogActions>
                <Grid container direction='row' justify='center' spacing={5}>
                    <Grid item>
                        <Box pb={5}>
                            <ButtonTemplate
                                variant='outlined'
                                color='primary'
                                size='small'
                                changetextcolor='#fff'
                                borderradius='5px'
                                onClick={() => setOpen(false)}
                            >Cancel</ButtonTemplate>
                        </Box>
                    </Grid>
                    <Grid item>
                        <Box pb={5}>
                            <ButtonTemplate
                                variant='contained'
                                color='primary'
                                size='small'
                                changetextcolor='#fff'
                                borderradius='5px'
                                onClick={handleCancel}
                                disabled={disabled}
                            >Agree</ButtonTemplate>
                        </Box>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}